import { ScrollArea } from '@mantine/core'
import { AppModal } from '@/components/ui'
import {
  PreviousTicketsRowsList,
  type PreviousTicketsRowsListProps,
} from '@/components/tickets/TicketDetailSidePanels'
import type { TicketListItem } from '@/types/api'

type TicketPreviousTicketsModalProps = {
  opened: boolean
  ticketsCount: number
  items: TicketListItem[]
  projectPick: PreviousTicketsRowsListProps['projectPick']
  onSelectTicket: PreviousTicketsRowsListProps['onSelectTicket']
  onOpenInNewTab: PreviousTicketsRowsListProps['onOpenInNewTab']
  tabStateById?: PreviousTicketsRowsListProps['tabStateById']
  onClose: () => void
}

export function TicketPreviousTicketsModal({
  opened,
  ticketsCount,
  items,
  projectPick,
  onSelectTicket,
  onOpenInNewTab,
  tabStateById,
  onClose,
}: TicketPreviousTicketsModalProps) {
  return (
    <AppModal
      opened={opened}
      onClose={onClose}
      title={`Прошлые обращения (${ticketsCount})`}
      size="lg"
      centered
    >
      <ScrollArea h={520} type="auto" offsetScrollbars>
        <PreviousTicketsRowsList
          items={items}
          projectPick={projectPick}
          onSelectTicket={onSelectTicket}
          onOpenInNewTab={onOpenInNewTab}
          tabStateById={tabStateById}
        />
      </ScrollArea>
    </AppModal>
  )
}
